import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  text: string;
  image?: string;
}
export function TestimonialCard({
  name,
  location,
  text,
  image
}: TestimonialCardProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100 flex flex-col h-full font-['Inter']" data-id="element-20">
      <div className="flex gap-1 mb-4" data-id="element-21">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#FF6B35] text-[#FF6B35]" data-id="element-22" />)}
      </div>

      <p className="text-[#333333] italic mb-6 flex-grow text-sm leading-relaxed" data-id="element-23">
        "{text}"
      </p>

      <div className="flex items-center gap-3 mt-auto" data-id="element-24">
        <div className="w-12 h-12 rounded-full bg-[#F5F5DC] flex items-center justify-center text-[#2D5A27] font-bold overflow-hidden border-2 border-[#2D5A27]/30" data-id="element-25">
          {image ? <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-26" /> : name.charAt(0)}
        </div>
        <div data-id="element-27">
          <p className="font-bold text-[#333333] text-sm font-['Inter']" data-id="element-28">
            {name}
          </p>
          <p className="text-xs text-[#2D5A27] font-medium" data-id="element-29">{location}</p>
        </div>
      </div>
    </div>;
}